import { removeNamespace } from '@piri/vue-utils';

import moduleName from './moduleName';
import mutationTypes from './types/mutationTypes';

const mutationTypesInModule = removeNamespace(moduleName, mutationTypes);

const sitesUpdated = (state, sites) => {
  Object.assign(state.sites, sites, { length: sites.length });
};

const siteUpdated = (state, site) => {
  Object.assign(state.site, site, { length: site.length });
};

export default {
  [mutationTypesInModule.SITES_UPDATED]: sitesUpdated,
  [mutationTypesInModule.SITE_UPDATED]: siteUpdated,
};
